(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moon-fawn-builder"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-mf-builder]').forEach((root) => {
  if (root.dataset.mfBound) return;
  root.dataset.mfBound = 'true';
  const form = root.querySelector('form');
  const box = root.querySelector('[data-mf-box]');
  const button = root.querySelector('[data-mf-submit]');
  const status = root.querySelector('[data-mf-status]');
  const error = root.querySelector('[data-mf-error]');
  const rows = [...root.querySelectorAll('.mf-builder__item')];
  const total = root.querySelector('[data-mf-total]');
  let sending = false;
  const selected = () => rows.filter(row => row.querySelector('[data-mf-include]').checked).map(row => row.querySelector('[data-mf-variant]').selectedOptions[0]).filter(option => option && !option.disabled);
  const update = () => {
    const packaging = box && box.selectedOptions[0];
    const products = selected();
    const ready = packaging && packaging.value && products.length > 0;
    const cents = products.reduce((sum, option) => sum + Number(option.dataset.price), packaging && packaging.value ? Number(packaging.dataset.price) : 0);
    total.textContent = new Intl.NumberFormat('en-GB', { style: 'currency', currency: root.dataset.currency || 'GBP' }).format(cents / 100);
    button.disabled = sending || !ready;
  };
  form.addEventListener('change', update);
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (sending || button.disabled) return;
    const packaging = box.selectedOptions[0];
    const products = selected();
    const group = crypto.randomUUID();
    const message = root.querySelector('[data-mf-message]').value.trim();
    const properties = { 'Gift box': 'Build your own', '_Gift box group': group };
    const items = [{ id: packaging.value, quantity: 1, properties: { ...properties, ...(message ? { 'Gift message': message } : {}) } }, ...products.map(option => ({ id: option.value, quantity: 1, properties: { ...properties } }))];
    sending = true;
    error.hidden = true;
    update();
    try {
      const response = await fetch(root.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
      if (!response.ok) throw new Error('Cart request failed');
      await response.json();
      window.location.assign(root.dataset.cartUrl);
    } catch (_) {
      error.hidden = false;
      status.textContent = error.textContent;
      sending = false;
      update();
    }
  });
  update();
});

  } catch(e) { console.error(e); }
})();
})();
